export enum Volumes {
    DEFAULT_BACKGROUND_VOLUME = 15,
    FULL_VOLUME = 100,
    SILENT = 0
};
